/* MV Sortiment assets/mv-sortiment.spiralen.js · Paket B-3a · 2026-10-08 */
/*
  Spiralen-Berater als Begleiter (Paket B-3a, Inhaber 08.10.2026: "Hier das ist der Default und wenn man was anderes
  braucht einen dann danach durchfuehren ... mehr grafisch und guided"). Vertrag: _docs/b3-spiralen.md.
  Erst der Standard (Buehne aus snippets/mv-spiralen-buehne.liquid), dann eine Entscheidung, dann drei Schritte:
  1 Produkt (Produktart-Kachel oder Bibliothek), 2 Masse (Formular mit Messskizze, Live-Vorschau in der Buehne),
  3 Ergebnis (Vergleich mit dem Standard, Stueckliste, Anfrage, Weiteres Produkt -> Merkliste). Expertenweg: Planer.

  Rechnen tut ausschliesslich assets/mv-sortiment.berater.js (eingefroren): Dieses Skript ruft dessen reine
  Funktionen (MV.berater) auf und fuehrt die vorhandene Instanz nur ueber ihre DOM-Haken - Klick auf die (verborgenen)
  Reiter, Werte und change/input-Ereignisse im Formular. berater.js schreibt weiter die URL (Vertrag Abschnitt 6 in
  _docs/e-berater.md); dieses Skript liest sie beim Start und uebersetzt sie in Modus und Schritt, ?weg=begleiter
  oeffnet den Begleiter. Reihenfolge im Buendel: berater.js steht vor spiralen.js, darum laufen dessen Listener auf
  document zuerst und dieses Skript sieht den Zustand danach.
  Teil 1: reine Funktionen (unter Node auf module.exports; die Logik von berater.js wird als Parameter B gereicht).
  Teil 2: Browser (Waechter window.__mvSortiment.spiralen, Delegation auf document, Zustand je Sektion).
  Neue Logik nur dort, wo der Auftrag sie verlangt: Vergleich mit der typischen Belegung (gleiche Ausfuehrung,
  naechstgelegene Groesse), Zusammenfassen der Stueckliste, Seitenansicht der Spirale, Merkliste. Vorschlag, das in
  berater.js zu uebernehmen: _docs/b3-spiralen.md. Keine Faktenzahlen: alle Groessen kommen aus dem JSON-Block.
  Merkliste im localStorage nur als Komfort (try/catch, ohne Speicher laeuft alles im Speicher der Seite).
  Nachtrag A-2b (10.10.2026, _docs/a2b-konto-werkzeuge.md): Die Merkliste speichert ueber das Kundenkonto
  (assets/mv-sortiment.konto.js, MVKonto) unter dem Werkzeug-Schluessel "spiralen": Stand { v: 1, eintraege, titel }
  (Eintraege wie bisher, titel = Namen der Produkte fuer "Meine Werkzeuge"). Ohne Login wie bisher nur im Browser
  (Spiegel mv-konto:spiralen), mit Login zusaetzlich im Konto; der Altschluessel SCHLUESSEL wandert einmalig in den
  Spiegel (MVKonto.migration). Leere Liste loescht den Stand, gleicher Stand speichert nichts. Mit Login zeigt die
  Merkliste einen abweichenden Konto-Stand (anderes Geraet, im Konto geloescht), solange sie auf der Seite noch nicht
  geaendert wurde; sonst gilt die Seite und geht ins Konto. Statuszeile am Ende des Kopfs (header.mv-berater__kopf): die
  Sektion bleibt unveraendert (sie steht in der md5-Kette von G-2/K-B), MVKonto baut die Zeile dort selbst; rendert die
  Sektion spaeter das Snippet mv-konto-hinweis, wird dieses gebunden. Mit MVKonto wird nur dort gespeichert (Plan,
  Vertrag Abschnitt 3); ohne MVKonto (Rueckfall) wie vor A-2b unter SCHLUESSEL.
*/
(function () {
  'use strict';

  // ===========================================================================================
  // Teil 1: reine Funktionen
  // ===========================================================================================

  var TEXTE = {
    schritt: 'Schritt {n} von {gesamt}: {titel}',
    vergleichPasst: 'Ebene {ebene}: {spirale} passt ab Werk.',
    vergleichPasstSatz: 'Sie brauchen keine andere Spirale.',
    vergleichTausch: 'Ebene {ebene}: {alt} \u2192 {neu}.',
    vergleichTauschSatz: 'Ab Werk sitzt dort die n\u00e4chstgelegene Gr\u00f6\u00dfe; tauschen Sie je Auswahl mit Ihrem Produkt eine Spirale.',
    hinweisPasst: 'Ihr Produkt passt hier',
    hinweisTausch: 'Hier tauschen: {alt} \u2192 {neu}',
    vorschau: '{spirale} \u00b7 Gangh\u00f6he {mm} mm \u00b7 Ihr Produkt {tiefe} mm, mit Spielraum {bedarf} mm',
    vorschauMass: 'Gangh\u00f6he {mm} mm',
    gewaehltArt: 'Produktart: {art}',
    gewaehltProdukt: 'Produkt: {name}',
    stueckZubehoer: {
      dosenfuehrung: 'Dosenf\u00fchrung: {n} St\u00fcck',
      produktfuehrung: 'Produktf\u00fchrung: {n} St\u00fcck',
      antrieb: 'Zweiter Antrieb oder Kupplung: {n} St\u00fcck'
    },
    eintragMasse: '{art}, {masse}',
    standardPasst: 'passt ab Werk (Ebene {ebene})',
    standardTausch: 'Tausch: Ebene {ebene}, {alt} \u2192 {neu}',
    mengeMinus: '{name}: eine Auswahl weniger',
    mengePlus: '{name}: eine Auswahl mehr',
    entfernen: '{name} entfernen',
    gemerkt: '{name} steht jetzt in Ihrer Konfiguration.',
    schonDa: '{name} steht schon in Ihrer Konfiguration.',
    entfernt: '{name} steht nicht mehr in Ihrer Konfiguration.',
    geleert: 'Ihre Konfiguration ist leer.',
    menge: '{name}: {auswahlen}.',
    konfAngebot: 'Spiralen-Berater: G-Snack {n} \u00b7 Typische Belegung ab Werk',
    konfEintrag: '{name}: {ergebnis}',
    nachricht: 'Bitte stellen Sie die Spiralen f\u00fcr meine Produkte ein. Meine Angaben: {konfiguration}.'
  };

  var SCHLUESSEL = 'mv-spiralen-konfiguration';
  var MAX_EINTRAEGE = 30;
  var WEGE_BEGLEITER = ['begleiter', 'beispiele', 'masse'];
  // Zeichnung der Seitenansicht (viewBox 0 0 320 116): Achse y 58, Windung zwischen y 28 und y 88, Massstab 2 px je mm
  var SEITE = { x0: 12, x1: 308, oben: 28, unten: 88, skala: 2, massY: 16 };

  function text(x) {
    return x == null ? '' : String(x);
  }

  function hat(o, k) {
    return !!o && Object.prototype.hasOwnProperty.call(o, k);
  }

  function istObjekt(x) {
    return !!x && typeof x === 'object' && !Array.isArray(x);
  }

  function enthaelt(liste, wert) {
    return liste.indexOf(wert) !== -1;
  }

  function ersetze(vorlage, werte) {
    return text(vorlage).replace(/\{(\w+)\}/g, function (ganz, name) {
      return hat(werte, name) ? text(werte[name]) : ganz;
    });
  }

  function rund(x) {
    return Math.round(x * 10) / 10;
  }

  function dekodiere(s) {
    try {
      return decodeURIComponent(text(s).replace(/\+/g, ' '));
    } catch (e) {
      return text(s);
    }
  }

  function anzahlFehler(erg) {
    return erg && istObjekt(erg.fehler) ? Object.keys(erg.fehler).length : 0;
  }

  function beispielVon(daten, id) {
    var liste = daten && Array.isArray(daten.beispiele) ? daten.beispiele : [];
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].id === text(id)) return liste[i];
    }
    return null;
  }

  function ebeneVon(daten, code) {
    var liste = daten && Array.isArray(daten.ebenen) ? daten.ebenen : [];
    for (var i = 0; i < liste.length; i++) {
      if (String(liste[i].code) === text(code)) return liste[i];
    }
    return null;
  }

  // hoechste Zahl der Auswahlen eines Automaten (Auswahlen je Ebene x Ebenen hoechstens), Grenze der Merkliste
  function maxAuswahlen(daten, code) {
    var e = ebeneVon(daten, code) || ebeneVon(daten, daten && daten.standard_ebene);
    return e ? Number(e.auswahlen) * Number(e.etagen_max) : 1;
  }

  // "Spirale 30" bzw. "Doppelspirale 55" aus den Vorlagen von berater.js
  function spiraleText(mm, doppel, B) {
    return ersetze(doppel ? B.TEXTE.doppelKurz : B.TEXTE.spiraleKurz, { mm: B.formatZahl(mm) });
  }

  function auswahlenText(n, B) {
    return Number(n) === 1 ? B.TEXTE.auswahlEins : ersetze(B.TEXTE.auswahlViele, { n: n });
  }

  // Vergleich mit der typischen Belegung (JSON werk_typisch, je Ebene von oben): gleiche Groesse und Ausfuehrung =
  // passt (erste solche Ebene); sonst die Ebene gleicher Ausfuehrung mit der naechstgelegenen Groesse (bei
  // Gleichstand die obere) - dort wird je Auswahl getauscht. Ohne Standardergebnis (Beratung, X10): null.
  function vergleich(erg, daten) {
    var d = istObjekt(daten) ? daten : {};
    if (!istObjekt(erg) || !erg.ok || !erg.groesse) return null;
    var reihen = Array.isArray(d.werk_typisch) ? d.werk_typisch : [];
    var doppel = erg.ausfuehrung === 'doppel';
    var mm = Number(erg.groesse.mm);
    var i;
    for (i = 0; i < reihen.length; i++) {
      if (Number(reihen[i].mm) === mm && !!reihen[i].doppel === doppel) {
        return { art: 'passt', ebene: i + 1, alt: null, neu: { mm: mm, doppel: doppel }, gruppe: text(reihen[i].gruppe) };
      }
    }
    var beste = -1;
    var abstand = Infinity;
    for (var runde = 0; runde < 2 && beste === -1; runde++) {
      for (i = 0; i < reihen.length; i++) {
        if (runde === 0 && !!reihen[i].doppel !== doppel) continue;
        var a = Math.abs(Number(reihen[i].mm) - mm);
        if (a < abstand) {
          abstand = a;
          beste = i;
        }
      }
    }
    if (beste === -1) return null;
    return { art: 'tausch', ebene: beste + 1, alt: { mm: Number(reihen[beste].mm), doppel: !!reihen[beste].doppel }, neu: { mm: mm, doppel: doppel }, gruppe: text(reihen[beste].gruppe) };
  }

  function vergleichTexte(v, B) {
    var t = { zeile: '', satz: '', hinweis: '', standard: '' };
    if (!v) return t;
    var neu = spiraleText(v.neu.mm, v.neu.doppel, B);
    if (v.art === 'passt') {
      t.zeile = ersetze(TEXTE.vergleichPasst, { ebene: v.ebene, spirale: neu });
      t.satz = TEXTE.vergleichPasstSatz;
      t.hinweis = TEXTE.hinweisPasst;
      t.standard = ersetze(TEXTE.standardPasst, { ebene: v.ebene });
      return t;
    }
    var alt = spiraleText(v.alt.mm, v.alt.doppel, B);
    t.zeile = ersetze(TEXTE.vergleichTausch, { ebene: v.ebene, alt: alt, neu: neu });
    t.satz = TEXTE.vergleichTauschSatz;
    t.hinweis = ersetze(TEXTE.hinweisTausch, { alt: alt, neu: neu });
    t.standard = ersetze(TEXTE.standardTausch, { ebene: v.ebene, alt: alt, neu: neu });
    return t;
  }

  function wegAusSuche(suche) {
    var paare = text(suche).replace(/^\?/, '').split('&');
    for (var i = 0; i < paare.length; i++) {
      var teil = paare[i].split('=');
      if (dekodiere(teil[0]) === 'weg') return dekodiere(teil.slice(1).join('='));
    }
    return '';
  }

  // URL -> Modus und Schritt (Vertrag Abschnitt 6 bleibt; ?weg=begleiter zusaetzlich): X10 -> Hinweis, weg=planen ->
  // Expertenweg, Beispiel oder Art mit Tiefe und Breite -> Ergebnis, Art oder ein Mass -> Masse, weg=begleiter,
  // beispiele oder masse -> Produkt, sonst Standard und Entscheidung
  function startZustand(suche, daten, B) {
    var z = B.spiralenAusSuche(suche, daten);
    var weg = wegAusSuche(suche);
    if (z.ebene === 'x10') return { modus: 'x10', schritt: 1 };
    if (z.weg === 'planen') return { modus: 'experte', schritt: 1 };
    if (z.bsp || (z.art && z.t != null && z.b != null)) return { modus: 'begleiter', schritt: 3 };
    if (z.art || z.t != null || z.b != null) return { modus: 'begleiter', schritt: 2 };
    if (enthaelt(WEGE_BEGLEITER, weg)) return { modus: 'begleiter', schritt: 1 };
    return { modus: 'start', schritt: 1 };
  }

  // Seitenansicht: Halbwellen im Abstand der halben Ganghoehe (wie die Messskizze), die Ware mittig in einer
  // Ganghoehe, Masslinie ueber dieser Ganghoehe
  function seitenansicht(e) {
    var mm = Number(e && e.mm);
    var tiefe = Number(e && e.tiefe);
    var aus = { d: '', halbe: 0, produkt: { x: 0, breite: 0 }, mass: '', massX: 0 };
    if (!(mm > 0)) return aus;
    var h = (mm * SEITE.skala) / 2;
    var n = Math.max(2, Math.floor((SEITE.x1 - SEITE.x0) / h + 1e-9));
    var x = SEITE.x0;
    var teile = ['M' + x + ' ' + SEITE.oben];
    for (var k = 1; k <= n; k++) {
      var ziel = k % 2 ? SEITE.unten : SEITE.oben;
      var mitte = rund(x + h / 2);
      var ende = rund(x + h);
      teile.push(k === 1 ? 'C' + mitte + ' ' + SEITE.oben + ' ' + mitte + ' ' + SEITE.unten + ' ' + ende + ' ' + SEITE.unten : 'S' + mitte + ' ' + ziel + ' ' + ende + ' ' + ziel);
      x += h;
    }
    var periode = Math.floor(n / 4);
    var links = SEITE.x0 + 2 * periode * h;
    var rechts = links + 2 * h;
    var breite = tiefe > 0 ? rund(tiefe * SEITE.skala) : 0;
    aus.d = teile.join(' ');
    aus.halbe = n;
    aus.produkt = { x: rund(links + h - breite / 2), breite: breite };
    aus.mass = 'M' + rund(links) + ' ' + SEITE.massY + 'H' + rund(rechts) + 'M' + rund(links) + ' ' + (SEITE.massY - 5) + 'V' + (SEITE.massY + 5) + 'M' + rund(rechts) + ' ' + (SEITE.massY - 5) + 'V' + (SEITE.massY + 5);
    aus.massX = rund(links + h);
    return aus;
  }

  // Stueckliste: Spiralen je Groesse und Ausfuehrung zusammengefasst (Reihenfolge wie die Bestueckungsliste des
  // Planers), danach das Zubehoer. posten: [{ erg, n, beschreibung }]; die Beschreibung (eig_Produkt) nur, wenn eine
  // Spirale zu genau einem Produkt gehoert, das sie mitbringt (Ergebnis eines Produkts = Link wie "Spirale bestellen").
  function stueckliste(posten, daten, B) {
    var liste = Array.isArray(posten) ? posten : [];
    var spiralen = {};
    var reihe = [];
    var zubehoer = { dosenfuehrung: 0, produktfuehrung: 0, antrieb: 0 };
    var ziel = {};
    for (var i = 0; i < liste.length; i++) {
      var p = liste[i];
      var erg = p && p.erg;
      if (!istObjekt(erg) || !erg.ok || !erg.groesse) continue;
      var n = Math.max(1, Math.floor(Number(p.n) || 1));
      var doppel = erg.ausfuehrung === 'doppel';
      var k = erg.groesse.mm + (doppel ? 'd' : 'e');
      if (!hat(spiralen, k)) {
        spiralen[k] = { mm: Number(erg.groesse.mm), doppel: doppel, anzahl: 0, erg: erg, beschreibung: text(p.beschreibung), produkte: 0 };
        reihe.push(k);
      }
      spiralen[k].anzahl += n;
      spiralen[k].produkte += 1;
      var t = B.spiralenTexte(erg, daten);
      for (var j = 0; j < t.zubehoer.length; j++) {
        var z = t.zubehoer[j];
        if (!hat(zubehoer, z.code)) continue;
        zubehoer[z.code] += n;
        ziel[z.code] = { url: z.url, link: z.link };
      }
    }
    reihe.sort(function (a, b) {
      return spiralen[a].mm - spiralen[b].mm || (spiralen[a].doppel ? 1 : 0) - (spiralen[b].doppel ? 1 : 0);
    });
    var aus = [];
    for (var r = 0; r < reihe.length; r++) {
      var s = spiralen[reihe[r]];
      var beschreibung = s.produkte === 1 ? s.beschreibung : '';
      aus.push({
        art: 'spirale',
        text: ersetze(s.doppel ? B.TEXTE.listeDoppel : B.TEXTE.listeEinzel, { mm: B.formatZahl(s.mm), anzahl: s.anzahl }),
        link: B.TEXTE.listeBestellen,
        url: B.bestellUrlSpirale(daten, s.erg, beschreibung).url
      });
    }
    var codes = ['dosenfuehrung', 'produktfuehrung', 'antrieb'];
    for (var c = 0; c < codes.length; c++) {
      if (!zubehoer[codes[c]]) continue;
      aus.push({ art: 'zubehoer', text: ersetze(TEXTE.stueckZubehoer[codes[c]], { n: zubehoer[codes[c]] }), link: ziel[codes[c]].link, url: ziel[codes[c]].url });
    }
    return aus;
  }

  // Eintrag der Merkliste: { bsp } oder { art, t, b, h, g, tol }, dazu n (Auswahlen)
  function schluessel(e) {
    if (!e) return '';
    if (e.bsp) return 'bsp:' + e.bsp;
    return 'mass:' + [e.art, e.t, e.b, e.h, e.g, e.tol].map(function (x) { return x == null ? '' : String(x); }).join(':');
  }

  function eingabeVon(e, ebene, daten) {
    var b = beispielVon(daten, e.bsp);
    if (b) return { ebene: ebene, art: b.art, tiefe: b.tiefe_mm, breite: b.breite_mm, hoehe: b.hoehe_mm, gewicht: b.gewicht_g, toleranz: '', bsp: b.id };
    return { ebene: ebene, art: e.art, tiefe: e.t, breite: e.b, hoehe: e.h == null ? '' : e.h, gewicht: e.g == null ? '' : e.g, toleranz: e.tol == null ? '' : e.tol, bsp: '' };
  }

  function eintragName(e, daten, B) {
    var b = beispielVon(daten, e && e.bsp);
    if (b) return b.name;
    var masse = [];
    if (e.t != null) masse.push('T ' + B.formatZahl(e.t));
    if (e.b != null) masse.push('B ' + B.formatZahl(e.b));
    if (e.h != null) masse.push('H ' + B.formatZahl(e.h));
    var art = text(B.TEXTE.arten[e.art]);
    return masse.length ? ersetze(TEXTE.eintragMasse, { art: art, masse: masse.join(' \u00d7 ') + ' mm' }) : art;
  }

  function ergebnisKurz(erg, B) {
    if (istObjekt(erg) && erg.ok && erg.groesse) return (erg.ausfuehrung === 'doppel' ? B.TEXTE.doppel : B.TEXTE.einzel) + ' ' + B.formatZahl(erg.groesse.mm);
    return B.TEXTE.konfBeratung;
  }

  // Konfiguration fuer die Lightbox (Vertrag Abschnitt 6): Angaben mit Mittelpunkt, ohne die Praefixe Menge:/Paket:,
  // hoechstens 900 Zeichen. eintraege: [{ name, erg, n }]
  function konfiguration(eintraege, ebene, daten, B) {
    var teile = [ebene === 'x10' ? B.TEXTE.konfX10 : ersetze(B.TEXTE.konfEbene, { ebene: ebene })];
    var liste = Array.isArray(eintraege) ? eintraege : [];
    for (var i = 0; i < liste.length; i++) {
      var e = liste[i];
      var zeile = ersetze(TEXTE.konfEintrag, { name: text(e.name).replace(/\s+\u00b7\s+/g, ', '), ergebnis: ergebnisKurz(e.erg, B) });
      if (Number(e.n) > 1) zeile += ', ' + auswahlenText(e.n, B);
      teile.push(zeile);
    }
    return (B.TEXTE.konfSpiralen + teile.join(B.TEXTE.trenner)).slice(0, 900);
  }

  function nachricht(konf) {
    return ersetze(TEXTE.nachricht, { konfiguration: konf }).slice(0, 2000);
  }

  function zahlOderNull(x, grenzen, B) {
    if (x == null || text(x).trim() === '') return null;
    var n = B.zahl(x);
    if (isNaN(n)) return undefined;
    if (Array.isArray(grenzen) && (n < grenzen[0] || n > grenzen[1])) return undefined;
    return n;
  }

  // Inhalt des Speichers pruefen: unbekannte Beispiele, ungueltige Masse und doppelte Eintraege fallen weg, die Menge
  // liegt zwischen 1 und dem Maximum des Automaten. Kaputter Inhalt ergibt eine leere Liste.
  function speicherLesen(roh, daten, B, max) {
    var obj = null;
    try {
      obj = JSON.parse(text(roh));
    } catch (e) {
      return [];
    }
    if (!istObjekt(obj) || obj.v !== 1 || !Array.isArray(obj.eintraege)) return [];
    var grenzen = istObjekt(daten && daten.grenzen) ? daten.grenzen : {};
    var obergrenze = Math.max(1, Number(max) || 1);
    var aus = [];
    var gesehen = {};
    for (var i = 0; i < obj.eintraege.length && aus.length < MAX_EINTRAEGE; i++) {
      var r = obj.eintraege[i];
      if (!istObjekt(r)) continue;
      var e;
      if (r.bsp != null) {
        if (!beispielVon(daten, r.bsp)) continue;
        e = { bsp: text(r.bsp) };
      } else {
        if (!hat(B.ARTEN, r.art)) continue;
        var t = zahlOderNull(r.t, grenzen.tiefe, B);
        var b = zahlOderNull(r.b, grenzen.breite, B);
        var h = zahlOderNull(r.h, grenzen.hoehe, B);
        var g = zahlOderNull(r.g, grenzen.gewicht, B);
        var tol = zahlOderNull(r.tol, grenzen.toleranz, B);
        if (t == null || b == null || h === undefined || g === undefined || tol === undefined) continue;
        e = { art: text(r.art), t: t, b: b, h: h, g: g, tol: tol };
      }
      var n = Math.floor(Number(r.n));
      e.n = Math.min(obergrenze, Math.max(1, isFinite(n) ? n : 1));
      var k = schluessel(e);
      if (hat(gesehen, k)) continue;
      gesehen[k] = true;
      aus.push(e);
    }
    return aus;
  }

  // ---- Kundenkonto (Paket A-2b): Stand der Merkliste fuer MVKonto ------------------------------

  var KONTO_WERKZEUG = 'spiralen';
  var TITEL_MAX = 80;

  // Titel fuer "Meine Werkzeuge" (Backend kuerzt auf 80 Zeichen): Leerraum zusammengefasst, sonst mit Auslassung
  function kurzTitel(t) {
    var s = text(t).replace(/\s+/g, ' ').trim();
    return s.length > TITEL_MAX ? s.slice(0, TITEL_MAX - 1).replace(/\s+$/, '') + '\u2026' : s;
  }

  // Stand { v: 1, eintraege, titel }: Eintraege wie im bisherigen Speicher, titel = Namen der Produkte
  function kontoStand(merk, daten, B) {
    var liste = Array.isArray(merk) ? merk : [];
    var eintraege = [];
    var namen = [];
    for (var i = 0; i < liste.length; i++) {
      var e = liste[i];
      if (!istObjekt(e)) continue;
      eintraege.push(e.bsp ? { bsp: e.bsp, n: e.n } : { art: e.art, t: e.t, b: e.b, h: e.h, g: e.g, tol: e.tol, n: e.n });
      if (B) namen.push(eintragName(e, daten, B));
    }
    var s = { v: 1, eintraege: eintraege };
    var titel = kurzTitel(namen.join(', '));
    if (titel) s.titel = titel;
    return s;
  }

  // Altstand oder Konto-Stand pruefen (Form des bisherigen Speichers); speicherLesen prueft danach jeden Eintrag
  function kontoStandPruefen(stand) {
    return istObjekt(stand) && stand.v === 1 && Array.isArray(stand.eintraege) ? { v: 1, eintraege: stand.eintraege } : null;
  }

  var api = {
    TEXTE: TEXTE,
    KONTO_WERKZEUG: KONTO_WERKZEUG,
    kontoStand: kontoStand,
    kontoStandPruefen: kontoStandPruefen,
    vergleich: vergleich,
    vergleichTexte: vergleichTexte,
    startZustand: startZustand,
    seitenansicht: seitenansicht,
    stueckliste: stueckliste,
    schluessel: schluessel,
    eintragName: eintragName,
    konfiguration: konfiguration,
    nachricht: nachricht,
    speicherLesen: speicherLesen
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.spiralen) return;
  MV.spiralen = api;

  var instanzen = typeof WeakMap === 'function' ? new WeakMap() : null;
  var bewegungReduziert = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var TEXTFELDER = ['tiefe', 'breite', 'hoehe', 'gewicht', 'toleranz'];

  function publiziere(name, daten) {
    try {
      var s = window.Shopify;
      if (s && s.analytics && typeof s.analytics.publish === 'function') s.analytics.publish(name, daten);
    } catch (e) { /* Analytics darf den Begleiter nie stoppen */ }
  }

  function zeige(el, an) {
    if (el) el.hidden = !an;
  }

  function setzeText(el, inhalt) {
    if (el && el.textContent !== text(inhalt)) el.textContent = text(inhalt);
  }

  function leere(el) {
    while (el && el.firstChild) el.removeChild(el.firstChild);
  }

  function ereignis(el, typ) {
    if (!el) return;
    var e;
    try {
      e = new Event(typ, { bubbles: true });
    } catch (x) {
      e = document.createEvent('Event');
      e.initEvent(typ, true, true);
    }
    el.dispatchEvent(e);
  }

  function fokus(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    if (typeof el.getBoundingClientRect === 'function' && typeof el.scrollIntoView === 'function') {
      var r = el.getBoundingClientRect();
      if (r.top < 0 || r.top > (window.innerHeight || 0) * 0.7) {
        try { el.scrollIntoView({ block: 'start', behavior: bewegungReduziert ? 'auto' : 'smooth' }); } catch (e2) { el.scrollIntoView(true); }
      }
    }
  }

  function datenLesen(w) {
    var el = w.querySelector('script[data-mv-berater-daten]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function speicherHolen() {
    try {
      return window.localStorage.getItem(SCHLUESSEL);
    } catch (e) {
      return null;
    }
  }

  function speicherSchreiben(wert) {
    try {
      if (wert == null) window.localStorage.removeItem(SCHLUESSEL);
      else window.localStorage.setItem(SCHLUESSEL, wert);
    } catch (e) { /* ohne Speicher bleibt die Liste auf der Seite */ }
  }

  // ---- Kundenkonto (Paket A-2b) ----------------------------------------------------------------

  // MVKonto (assets/mv-sortiment.konto.js) steht im Buendel vor dieser Datei; trotzdem erst beim Aufruf aufloesen. Mit
  // MVKonto speichert die Merkliste nur dort (SCHLUESSEL ist dann Altschluessel fuer die Migration); ohne MVKonto
  // (Rueckfall, etwa beim Rueckweg von A-2a) wie vor A-2b unter SCHLUESSEL.
  function kontoApi() {
    var k = window.MVKonto;
    return k && typeof k.lokal === 'function' && typeof k.speichern === 'function' && typeof k.lesen === 'function' &&
      typeof k.loeschen === 'function' && typeof k.migration === 'function' ? k : null;
  }

  // Altschluessel einmalig in den Spiegel (verschoben, nicht geteilt; ohne Zeitstempel verliert er gegen jeden
  // Konto-Stand): derselbe Inhalt { v: 1, eintraege }
  function kontoAnmelden(mv) {
    mv.migration(/^spiralen$/, {
      geteilt: false,
      alt: function () { return SCHLUESSEL; },
      lesen: function (roh) { return api.kontoStandPruefen(JSON.parse(roh)); }
    });
  }

  function Begleiter(w) {
    this.w = w;
    this.B = MV.berater;
    this.daten = datenLesen(w);
    this.modus = 'start';
    this.schritt = 1;
    this.vorX10 = { modus: 'start', schritt: 1 };
    this.hinweis = false;
    this.merk = [];
  }

  Begleiter.prototype.q = function (sel) {
    return this.w.querySelector(sel);
  };

  Begleiter.prototype.alle = function (sel) {
    return Array.prototype.slice.call(this.w.querySelectorAll(sel));
  };

  // Eingaben so, wie berater.js sie liest (roh): Automat, Produktart, Felder, gedrueckte Karte der Bibliothek
  Begleiter.prototype.roh = function () {
    var w = this.w;
    var feld = function (n) {
      var el = w.querySelector('[data-mv-berater-feld="' + n + '"]:not([type="radio"])');
      return el ? el.value : '';
    };
    var radio = function (n) {
      var el = w.querySelector('input[type="radio"][data-mv-berater-feld="' + n + '"]:checked');
      return el ? el.value : '';
    };
    var karte = w.querySelector('[data-mv-spiralen-beispiel][aria-pressed="true"]');
    return {
      ebene: radio('ebene') || text(this.daten.standard_ebene), art: radio('art'), tiefe: feld('tiefe'), breite: feld('breite'),
      hoehe: feld('hoehe'), gewicht: feld('gewicht'), toleranz: feld('toleranz'), bsp: karte ? karte.getAttribute('data-mv-spiralen-beispiel') : ''
    };
  };

  Begleiter.prototype.ergebnis = function (roh) {
    return this.B.spiraleFuer(roh || this.roh(), this.daten);
  };

  Begleiter.prototype.altAktiv = function () {
    var tab = this.q('[role="tab"][aria-selected="true"]');
    return tab ? tab.getAttribute('data-mv-berater-reiter') : '';
  };

  // Reiter von berater.js schalten (verborgen): berater.js zeigt das Panel, das Ergebnis und schreibt die URL
  Begleiter.prototype.altReiter = function (name) {
    var tab = this.q('[role="tab"][data-mv-berater-reiter="' + name + '"]');
    if (!tab || tab.getAttribute('aria-selected') === 'true') return;
    var vorher = document.activeElement;
    this.intern = true;
    try {
      tab.click();
    } finally {
      this.intern = false;
    }
    // berater.js fokussiert den Reiter; er ist verborgen, darum bleibt der Fokus, wo er war
    if (document.activeElement === tab) {
      if (vorher && vorher !== tab && vorher !== document.body && typeof vorher.focus === 'function') vorher.focus();
      else if (typeof tab.blur === 'function') tab.blur();
    }
  };

  Begleiter.prototype.hatErgebnis = function () {
    var box = this.q('[data-mv-berater-ergebnis]');
    return !!box && !box.hidden && this.altAktiv() !== 'planen';
  };

  Begleiter.prototype.start = function () {
    if (!this.B) return;
    var w = this.w;
    var z = startZustand(window.location.search, this.daten, this.B);
    // A-2b: mit MVKonto liest die Merkliste aus dem Spiegel (Altschluessel einmalig uebernommen), sonst wie bisher
    var mv = kontoApi();
    if (mv) kontoAnmelden(mv);
    this.konto = mv;
    this.geaendert = false;
    this.merk = speicherLesen(mv ? this.kontoRoh(mv) : speicherHolen(), this.daten, this.B, maxAuswahlen(this.daten, this.roh().ebene));
    if (mv) this.kontoText = JSON.stringify(api.kontoStand(this.merk, this.daten, this.B));
    // was der Begleiter ersetzt: Reiterleiste, zweite Frage nach der Produktart, Hauptknoepfe des alten Ergebnisses
    zeige(this.q('[role="tablist"]'), false);
    zeige(this.q('.mv-spiralen-arten'), false);
    zeige(this.q('[data-mv-spiralbegleiter-alt]'), false);
    var schalter = this.q('[data-mv-spiralbegleiter-merk-schalter]');
    if (schalter && window.matchMedia && window.matchMedia('(max-width: 999.98px)').matches) this.merkAufklappen(false);
    this.modus = z.modus;
    this.schritt = z.schritt;
    if (z.modus === 'begleiter' && z.schritt === 3 && !this.hatErgebnis()) this.schritt = this.roh().art ? 2 : 1;
    if (this.modus === 'begleiter' && this.schritt === 1) this.altReiter('beispiele');
    if (this.modus === 'begleiter' && this.schritt === 2) this.altReiter('masse');
    if (this.modus === 'x10') this.vorX10 = { modus: 'start', schritt: 1 };
    this.anwenden({});
    w.setAttribute('data-mv-spiralbegleiter-bereit', '');
    if (mv) this.kontoStart(mv);
  };

  // ---- Kundenkonto (Paket A-2b) ----------------------------------------------------------------

  // Spiegel synchron lesen (migriert den Altschluessel beim ersten Mal); als Text fuer speicherLesen
  Begleiter.prototype.kontoRoh = function (mv) {
    var e = mv.lokal(api.KONTO_WERKZEUG);
    var s = e ? api.kontoStandPruefen(e.stand) : null;
    return s ? JSON.stringify(s) : null;
  };

  // Statuszeile binden; mit Login den Konto-Stand abgleichen
  Begleiter.prototype.kontoStart = function (mv) {
    var self = this;
    // aus dem Snippet der Sektion; fehlt es, baut MVKonto die Zeile am Ende des Kopfs (header.mv-berater__kopf)
    var box = this.q('[data-mv-konto-hinweis]') || this.q('.mv-berater__kopf');
    if (box && typeof mv.hinweis === 'function') mv.hinweis(box, api.KONTO_WERKZEUG);
    if (typeof mv.eingeloggt !== 'function' || !mv.eingeloggt()) return;
    mv.lesen(api.KONTO_WERKZEUG).then(function (r) { self.kontoAbgleich(r); }, function () { /* Konto nicht erreichbar: Browser-Stand gilt */ });
  };

  // Antwort des Kontos: abweichender Stand (anderes Geraet) oder im Konto geloescht. Auf der Seite schon geaendert:
  // die Seite gilt und geht wieder ins Konto (auch bei nachgehender Geraeteuhr). Sonst zeigt die Merkliste den
  // Konto-Stand.
  Begleiter.prototype.kontoAbgleich = function (r) {
    if (!r || (!r.neu && !r.verworfen)) return;
    if (this.geaendert) {
      this.kontoSpeichern(true);
      return;
    }
    var s = r.verworfen ? null : api.kontoStandPruefen(r.stand);
    var ebene = this.roh().ebene;
    this.merk = s ? speicherLesen(JSON.stringify(s), this.daten, this.B, maxAuswahlen(this.daten, ebene === 'x10' ? this.daten.standard_ebene : ebene)) : [];
    this.kontoText = JSON.stringify(api.kontoStand(this.merk, this.daten, this.B));
    this.merkZeigen();
  };

  // Ganzer Stand in Spiegel und Konto, nur bei einer echten Aenderung (immer = nach dem Abgleich, die Seite gilt);
  // leere Merkliste -> loeschen
  Begleiter.prototype.kontoSpeichern = function (immer) {
    var s = api.kontoStand(this.merk, this.daten, this.B);
    var t = JSON.stringify(s);
    if (!immer && t === this.kontoText) return;
    this.kontoText = t;
    this.geaendert = true;
    if (!s.eintraege.length) this.konto.loeschen(api.KONTO_WERKZEUG);
    else this.konto.speichern(api.KONTO_WERKZEUG, s);
  };

  Begleiter.prototype.schrittTitel = function (n) {
    var b = this.q('[data-mv-spiralbegleiter-gehe="' + n + '"] .mv-spiralbegleiter__punkt-text');
    return b ? b.textContent.replace(/\s+/g, ' ').trim() : '';
  };

  Begleiter.prototype.anwenden = function (o) {
    var opt = o || {};
    var w = this.w;
    var m = this.modus;
    var imBegleiter = m === 'begleiter' || m === 'experte';
    w.setAttribute('data-mv-spiralbegleiter-modus', m);
    w.setAttribute('data-mv-spiralbegleiter-stufe', String(this.schritt));
    zeige(this.q('[data-mv-spiralbegleiter-entscheidung]'), m !== 'x10');
    zeige(this.q('[data-mv-spiralbegleiter-ja]'), m === 'ja');
    zeige(this.q('[data-mv-spiralbegleiter-begleiter]'), imBegleiter);
    zeige(this.q('[data-mv-spiralbegleiter-listen]'), !imBegleiter);
    var ja = this.q('[data-mv-spiralbegleiter-wahl="ja"]');
    var nein = this.q('[data-mv-spiralbegleiter-wahl="nein"]');
    if (ja) ja.setAttribute('aria-expanded', m === 'ja' ? 'true' : 'false');
    if (nein) nein.setAttribute('aria-expanded', imBegleiter ? 'true' : 'false');
    var self = this;
    this.alle('[data-mv-spiralbegleiter-schritt]').forEach(function (s) {
      var n = s.getAttribute('data-mv-spiralbegleiter-schritt');
      zeige(s, (m === 'begleiter' && n === String(self.schritt)) || (m === 'experte' && n === 'experte'));
    });
    zeige(this.q('[data-mv-spiralbegleiter-zurueck]'), m === 'begleiter');
    zeige(this.q('[data-mv-spiralbegleiter-weiter]'), m === 'begleiter' && this.schritt === 1);
    zeige(this.q('[data-mv-spiralbegleiter-fortschritt]'), m === 'begleiter');
    zeige(this.q('[data-mv-spiralbegleiter-hinweis]'), m === 'begleiter' && this.schritt === 1 && this.hinweis);
    this.fortschrittZeigen();
    this.statusZeigen(opt.meldung, true);
    this.kachelnZeigen();
    this.gewaehltZeigen();
    this.buehneZeigen();
    this.ergebnisZusatz();
    this.angebotSetzen();
    this.merkZeigen();
  };

  Begleiter.prototype.fortschrittZeigen = function () {
    var roh = this.roh();
    var erreichbar = { 1: true, 2: !!roh.art || !!roh.bsp, 3: this.hatErgebnis() };
    var self = this;
    this.alle('[data-mv-spiralbegleiter-gehe]').forEach(function (b) {
      var n = b.getAttribute('data-mv-spiralbegleiter-gehe');
      var aktuell = self.modus === 'begleiter' && String(self.schritt) === n;
      b.disabled = !aktuell && !erreichbar[n];
      if (aktuell) b.setAttribute('aria-current', 'step');
      else b.removeAttribute('aria-current');
      b.setAttribute('data-erledigt', !aktuell && erreichbar[n] && Number(n) < self.schritt ? 'ja' : 'nein');
    });
  };

  // sichtbare Live-Region: Schritt (nur im Begleiter), davor eine Meldung; mitSchritt false = nur die Meldung
  Begleiter.prototype.statusZeigen = function (meldung, mitSchritt) {
    var el = this.q('[data-mv-spiralbegleiter-status]');
    if (!el) return;
    var schritt = this.modus === 'begleiter' && mitSchritt !== false ? ersetze(TEXTE.schritt, { n: this.schritt, gesamt: 3, titel: this.schrittTitel(this.schritt) }) : '';
    if (meldung == null && mitSchritt !== false && el.getAttribute('data-schritt') === String(this.modus + this.schritt)) return;
    el.setAttribute('data-schritt', String(this.modus + this.schritt));
    setzeText(el, [text(meldung), schritt].filter(function (x) { return !!x; }).join(' '));
  };

  Begleiter.prototype.kachelnZeigen = function () {
    var roh = this.roh();
    this.alle('[data-mv-spiralbegleiter-art]').forEach(function (k) {
      k.setAttribute('aria-pressed', !roh.bsp && roh.art === k.getAttribute('data-mv-spiralbegleiter-art') ? 'true' : 'false');
    });
  };

  Begleiter.prototype.gewaehltZeigen = function () {
    var p = this.q('[data-mv-spiralbegleiter-gewaehlt]');
    if (!p) return;
    var roh = this.roh();
    var b = beispielVon(this.daten, roh.bsp);
    var t = b ? ersetze(TEXTE.gewaehltProdukt, { name: b.name }) : (roh.art ? ersetze(TEXTE.gewaehltArt, { art: this.B.TEXTE.arten[roh.art] }) : '');
    setzeText(p.querySelector('[data-mv-spiralbegleiter-slot="gewaehlt"]'), t);
    zeige(p, !!t);
  };

  // Buehne: Figur der gewaehlten Breite; in Schritt 2 und 3 hebt sich die betroffene Ebene hervor, und die
  // Seitenansicht zeichnet die Spirale mit ihrer Ganghoehe
  Begleiter.prototype.buehneZeigen = function () {
    var roh = this.roh();
    var ebene = roh.ebene;
    this.alle('[data-mv-spiralbuehne-modell]').forEach(function (f) {
      zeige(f, f.getAttribute('data-mv-spiralbuehne-modell') === ebene);
    });
    this.alle('[data-mv-spiralbuehne-reihe][data-an], [data-mv-spiralbuehne-ebene][data-an]').forEach(function (el) {
      el.removeAttribute('data-an');
    });
    this.alle('[data-mv-spiralbuehne-hinweis]').forEach(function (el) {
      setzeText(el, '');
    });
    var vorschau = this.q('[data-mv-spiralbuehne-vorschau]');
    var erg = this.modus === 'begleiter' && this.schritt >= 2 && ebene !== 'x10' ? this.ergebnis(roh) : null;
    var v = erg ? vergleich(erg, this.daten) : null;
    var figur = this.q('[data-mv-spiralbuehne-modell="' + ebene + '"]');
    if (v && figur) {
      var texte = vergleichTexte(v, this.B);
      var ziel = String(v.ebene);
      var reihe = figur.querySelector('[data-mv-spiralbuehne-reihe="' + ziel + '"]');
      var zeile = figur.querySelector('[data-mv-spiralbuehne-ebene="' + ziel + '"]');
      if (reihe) reihe.setAttribute('data-an', v.art);
      if (zeile) {
        zeile.setAttribute('data-an', v.art);
        setzeText(zeile.querySelector('[data-mv-spiralbuehne-hinweis]'), texte.hinweis);
      }
    }
    if (!vorschau) return;
    if (!v) {
      zeige(vorschau, false);
      return;
    }
    var s = seitenansicht({ mm: erg.groesse.mm, tiefe: erg.tiefe });
    var setze = function (sel, name, wert) {
      var el = vorschau.querySelector(sel);
      if (el) el.setAttribute(name, String(wert));
    };
    setze('[data-mv-spiralbuehne-spirale]', 'd', s.d);
    setze('[data-mv-spiralbuehne-produkt]', 'x', s.produkt.x);
    setze('[data-mv-spiralbuehne-produkt]', 'width', s.produkt.breite);
    setze('[data-mv-spiralbuehne-mass]', 'd', s.mass);
    setze('[data-mv-spiralbuehne-mass-text]', 'x', s.massX);
    var mm = this.B.formatZahl(erg.groesse.mm);
    setzeText(vorschau.querySelector('[data-mv-spiralbuehne-mass-text]'), ersetze(TEXTE.vorschauMass, { mm: mm }));
    setzeText(vorschau.querySelector('[data-mv-spiralbuehne-vorschau-text]'), ersetze(TEXTE.vorschau, {
      spirale: spiraleText(erg.groesse.mm, erg.ausfuehrung === 'doppel', this.B), mm: mm, tiefe: this.B.formatZahl(erg.tiefe), bedarf: this.B.formatZahl(erg.bedarf)
    }));
    zeige(vorschau, true);
  };

  Begleiter.prototype.listeFuellen = function (ul, punkte) {
    if (!ul) return;
    leere(ul);
    var vorlage = this.q('template[data-mv-spiralbegleiter-vorlage="stueck"]');
    for (var i = 0; i < punkte.length; i++) {
      var li = vorlage && vorlage.content && vorlage.content.firstElementChild ? vorlage.content.firstElementChild.cloneNode(true) : null;
      if (!li) break;
      setzeText(li.querySelector('[data-mv-spiralbegleiter-slot="text"]'), punkte[i].text);
      var a = li.querySelector('[data-mv-spiralbegleiter-slot="link"]');
      if (a) {
        a.setAttribute('href', punkte[i].url);
        a.textContent = punkte[i].link;
        if (punkte[i].art === 'spirale') a.setAttribute('data-mv-spiralen-bestellen-liste', '');
      }
      ul.appendChild(li);
    }
  };

  // Ergebnis (Schritt 3): Vergleich mit dem Standard, Stueckliste dieses Produkts, Aktionen des Begleiters
  Begleiter.prototype.ergebnisZusatz = function () {
    var roh = this.roh();
    var erg = this.ergebnis(roh);
    var gueltig = !anzahlFehler(erg) && !erg.x10;
    var aktiv = this.modus === 'begleiter';
    var v = gueltig ? vergleich(erg, this.daten) : null;
    var box = this.q('[data-mv-spiralbegleiter-vergleich]');
    if (box) {
      var t = vergleichTexte(v, this.B);
      setzeText(box.querySelector('[data-mv-spiralbegleiter-slot="vergleich-zeile"]'), t.zeile);
      setzeText(box.querySelector('[data-mv-spiralbegleiter-slot="vergleich-satz"]'), t.satz);
      zeige(box, aktiv && !!v);
    }
    var stk = this.q('[data-mv-spiralbegleiter-stueckliste]');
    var punkte = gueltig && erg.ok ? stueckliste([{ erg: erg, n: 1, beschreibung: this.B.produktBeschreibung(roh, this.daten) }], this.daten, this.B) : [];
    if (stk) {
      this.listeFuellen(stk.querySelector('[data-mv-spiralbegleiter-slot="stueckliste"]'), punkte);
      zeige(stk, aktiv && punkte.length > 0);
    }
    zeige(this.q('[data-mv-spiralbegleiter-aktionen]'), aktiv && gueltig);
    zeige(this.q('[data-mv-spiralbegleiter-alt]'), false);
  };

  // Ja-Weg: Angebot und Planer-Vorlage folgen der Breite an der Buehne
  Begleiter.prototype.angebotSetzen = function () {
    var ebene = this.roh().ebene;
    if (ebene === 'x10') return;
    var a = this.q('[data-mv-spiralbegleiter-angebot]');
    if (a) a.setAttribute('data-konfiguration', ersetze(TEXTE.konfAngebot, { n: ebene }));
    var f = this.q('[data-mv-spiralbegleiter-faecher]');
    if (f) f.setAttribute('data-mv-spiralen-werk-planer', 'g' + ebene);
  };

  // aktuelles Produkt als Eintrag (nur mit Ergebnis oder Beratung, nicht beim X10)
  Begleiter.prototype.aktuellerEintrag = function () {
    var roh = this.roh();
    var erg = this.ergebnis(roh);
    if (anzahlFehler(erg) || erg.x10) return null;
    if (roh.bsp && beispielVon(this.daten, roh.bsp)) return { bsp: roh.bsp, n: 1 };
    var B = this.B;
    var g = this.daten.grenzen || {};
    var e = { art: roh.art, t: zahlOderNull(roh.tiefe, g.tiefe, B), b: zahlOderNull(roh.breite, g.breite, B), h: zahlOderNull(roh.hoehe, g.hoehe, B), g: zahlOderNull(roh.gewicht, g.gewicht, B), tol: zahlOderNull(roh.toleranz, g.toleranz, B), n: 1 };
    for (var k in e) {
      if (hat(e, k) && e[k] === undefined) e[k] = null;
    }
    return e;
  };

  Begleiter.prototype.merkIndex = function (k) {
    for (var i = 0; i < this.merk.length; i++) {
      if (schluessel(this.merk[i]) === k) return i;
    }
    return -1;
  };

  // A-2b: mit MVKonto nur dort (Stand wie bisher, dazu titel); ohne MVKonto wie vor A-2b
  Begleiter.prototype.speichern = function () {
    if (this.konto) {
      this.kontoSpeichern(false);
      return;
    }
    if (!this.merk.length) {
      speicherSchreiben(null);
      return;
    }
    speicherSchreiben(JSON.stringify({
      v: 1,
      eintraege: this.merk.map(function (e) {
        return e.bsp ? { bsp: e.bsp, n: e.n } : { art: e.art, t: e.t, b: e.b, h: e.h, g: e.g, tol: e.tol, n: e.n };
      })
    }));
  };

  Begleiter.prototype.merkAufklappen = function (auf) {
    var schalter = this.q('[data-mv-spiralbegleiter-merk-schalter]');
    if (!schalter) return;
    schalter.setAttribute('aria-expanded', auf ? 'true' : 'false');
    zeige(this.q('[data-mv-spiralbegleiter-merk-inhalt]'), auf);
  };

  // Merkliste: Eintraege mit Ergebnis der gewaehlten Breite, Stueckliste ueber alle Eintraege, Lightbox-Oeffner
  Begleiter.prototype.merkZeigen = function () {
    var aside = this.q('[data-mv-spiralbegleiter-merkliste]');
    if (!aside) return;
    var B = this.B;
    var daten = this.daten;
    var ebene = this.roh().ebene;
    var rechenEbene = ebene === 'x10' ? text(daten.standard_ebene) : ebene;
    var max = maxAuswahlen(daten, rechenEbene);
    var leer = this.merk.length === 0;
    zeige(aside, this.modus !== 'x10' && (!leer || this.modus === 'begleiter' || this.modus === 'experte'));
    setzeText(this.q('[data-mv-spiralbegleiter-merk-zahl]'), leer ? '' : String(this.merk.length));
    zeige(this.q('[data-mv-spiralbegleiter-merk-leer]'), leer);
    var ul = this.q('[data-mv-spiralbegleiter-merk-liste]');
    var vorlage = this.q('template[data-mv-spiralbegleiter-vorlage="eintrag"]');
    var posten = [];
    var konf = [];
    if (ul) leere(ul);
    for (var i = 0; i < this.merk.length; i++) {
      var e = this.merk[i];
      e.n = Math.min(max, Math.max(1, e.n || 1));
      var erg = B.spiraleFuer(eingabeVon(e, rechenEbene, daten), daten);
      var name = eintragName(e, daten, B);
      posten.push({ erg: erg, n: e.n });
      konf.push({ name: name, erg: erg, n: e.n });
      if (!ul || !vorlage || !vorlage.content || !vorlage.content.firstElementChild) continue;
      var li = vorlage.content.firstElementChild.cloneNode(true);
      li.setAttribute('data-mv-spiralbegleiter-eintrag', schluessel(e));
      var karte = erg.ok && erg.groesse ? ersetze(B.TEXTE.karte, { ausfuehrung: erg.ausfuehrung === 'doppel' ? B.TEXTE.doppel : B.TEXTE.einzel, mm: B.formatZahl(erg.groesse.mm), n: erg.groesse.stueck }) : B.TEXTE.beispielBeratung;
      var slot = function (n) { return li.querySelector('[data-mv-spiralbegleiter-slot="' + n + '"]'); };
      setzeText(slot('name'), name);
      setzeText(slot('ergebnis'), karte);
      setzeText(slot('standard'), vergleichTexte(vergleich(erg, daten), B).standard);
      setzeText(slot('auswahlen'), auswahlenText(e.n, B));
      setzeText(slot('minus'), ersetze(TEXTE.mengeMinus, { name: name }));
      setzeText(slot('plus'), ersetze(TEXTE.mengePlus, { name: name }));
      setzeText(slot('entfernen'), ersetze(TEXTE.entfernen, { name: name }));
      var minus = li.querySelector('[data-mv-spiralbegleiter-menge="minus"]');
      var plus = li.querySelector('[data-mv-spiralbegleiter-menge="plus"]');
      if (minus) minus.disabled = e.n <= 1;
      if (plus) plus.disabled = e.n >= max;
      ul.appendChild(li);
    }
    zeige(ul, !leer);
    var summe = this.q('[data-mv-spiralbegleiter-merk-summe]');
    this.listeFuellen(this.q('[data-mv-spiralbegleiter-merk-stueckliste]'), stueckliste(posten, daten, B));
    zeige(summe, !leer);
    // aktuelles Produkt (Schritt 3) gehoert zur Anfrage, auch bevor es gemerkt ist
    var aktuell = this.modus === 'begleiter' && this.schritt === 3 ? this.aktuellerEintrag() : null;
    if (aktuell && this.merkIndex(schluessel(aktuell)) === -1) konf.push({ name: eintragName(aktuell, daten, B), erg: this.ergebnis(), n: 1 });
    var k = konfiguration(konf, rechenEbene, daten, B);
    var n = nachricht(k);
    this.alle('[data-mv-spiralbegleiter-anfrage]').forEach(function (a) {
      a.setAttribute('data-konfiguration', k);
      a.setAttribute('data-nachricht', n);
    });
  };

  Begleiter.prototype.fokusSchritt = function () {
    var ziel;
    if (this.modus === 'experte') ziel = this.q('[data-mv-spiralbegleiter-schritt="experte"] [data-mv-spiralbegleiter-schritt-titel]');
    else if (this.schritt === 3) ziel = this.q('[data-mv-berater-ergebnis-titel]');
    else ziel = this.q('[data-mv-spiralbegleiter-schritt="' + this.schritt + '"] [data-mv-spiralbegleiter-schritt-titel]');
    fokus(ziel);
  };

  // Schritt 1 zeigt den Reiter Beispiele (Bibliothek), Schritt 2 den Reiter Masse eingeben; Schritt 3 nur mit Ergebnis
  Begleiter.prototype.zuSchritt = function (n, o) {
    var opt = o || {};
    var ziel = n;
    this.modus = 'begleiter';
    this.hinweis = false;
    if (ziel === 3) {
      if (this.altAktiv() === 'planen') this.altReiter('masse');
      if (!this.hatErgebnis()) ziel = this.roh().art ? 2 : 1;
    }
    if (ziel === 1) this.altReiter('beispiele');
    else if (ziel === 2) this.altReiter('masse');
    this.schritt = ziel;
    this.anwenden({ meldung: opt.meldung });
    if (opt.fokus) this.fokusSchritt();
  };

  Begleiter.prototype.experte = function (o) {
    this.altReiter('planen');
    this.modus = 'experte';
    this.anwenden({});
    if (!o || o.fokus !== false) this.fokusSchritt();
  };

  // Formular leeren fuer das naechste Produkt; berater.js rechnet neu (Ergebnis weg, URL ohne Masse, Beispiel vergessen)
  Begleiter.prototype.formLeeren = function () {
    var w = this.w;
    TEXTFELDER.forEach(function (n) {
      var el = w.querySelector('[data-mv-berater-feld="' + n + '"]:not([type="radio"])');
      if (el) el.value = '';
    });
    this.alle('input[type="radio"][data-mv-berater-feld="art"]').forEach(function (r) {
      r.checked = false;
    });
    ereignis(w.querySelector('[data-mv-berater-feld="tiefe"]:not([type="radio"])'), 'input');
  };

  Begleiter.prototype.weiteres = function () {
    var e = this.aktuellerEintrag();
    var meldung = null;
    if (e) {
      var name = eintragName(e, this.daten, this.B);
      if (this.merkIndex(schluessel(e)) !== -1) {
        meldung = ersetze(TEXTE.schonDa, { name: name });
      } else if (this.merk.length < MAX_EINTRAEGE) {
        this.merk.push(e);
        this.speichern();
        meldung = ersetze(TEXTE.gemerkt, { name: name });
      }
    }
    this.formLeeren();
    this.zuSchritt(1, { meldung: meldung, fokus: true });
    publiziere('berater_cta', { berater: 'spiralen', ziel: 'weiteres' });
  };

  Begleiter.prototype.merkAktion = function (ziel) {
    var li = ziel.closest('[data-mv-spiralbegleiter-eintrag]');
    var i = li ? this.merkIndex(li.getAttribute('data-mv-spiralbegleiter-eintrag')) : -1;
    if (i === -1) return;
    var e = this.merk[i];
    var name = eintragName(e, this.daten, this.B);
    var meldung;
    var knopf = ziel.closest('[data-mv-spiralbegleiter-menge]');
    if (knopf) {
      if (knopf.disabled) return;
      var max = maxAuswahlen(this.daten, this.roh().ebene === 'x10' ? this.daten.standard_ebene : this.roh().ebene);
      e.n = Math.min(max, Math.max(1, e.n + (knopf.getAttribute('data-mv-spiralbegleiter-menge') === 'plus' ? 1 : -1)));
      meldung = ersetze(TEXTE.menge, { name: name, auswahlen: auswahlenText(e.n, this.B) });
    } else {
      this.merk.splice(i, 1);
      meldung = ersetze(TEXTE.entfernt, { name: name });
    }
    this.speichern();
    this.merkZeigen();
    this.statusZeigen(meldung, false);
    // Fokus bleibt in der Liste: gleicher Knopf bzw. naechster Eintrag oder der Titel
    if (knopf) {
      var neu = this.q('[data-mv-spiralbegleiter-eintrag="' + schluessel(e) + '"] [data-mv-spiralbegleiter-menge="' + knopf.getAttribute('data-mv-spiralbegleiter-menge') + '"]');
      if (neu && !neu.disabled) fokus(neu);
      else fokus(this.q('[data-mv-spiralbegleiter-eintrag="' + schluessel(e) + '"] [data-mv-spiralbegleiter-menge]:not([disabled])'));
    } else {
      fokus(this.q('[data-mv-spiralbegleiter-merk-liste] [data-mv-spiralbegleiter-entfernen]') || this.q('[data-mv-spiralbegleiter-merk-schalter]'));
    }
  };

  Begleiter.prototype.klick = function (e) {
    if (this.intern) return;
    var ziel = e.target;
    var el;
    if ((el = ziel.closest('[data-mv-spiralbegleiter-wahl]'))) {
      var wahl = el.getAttribute('data-mv-spiralbegleiter-wahl');
      if (wahl === 'ja') {
        if (this.modus === 'ja') {
          this.modus = 'start';
          this.anwenden({});
          return;
        }
        this.modus = 'ja';
        this.anwenden({});
        fokus(this.q('[data-mv-spiralbegleiter-ja-titel]'));
        publiziere('berater_cta', { berater: 'spiralen', ziel: 'standard' });
      } else {
        if (this.modus === 'begleiter' || this.modus === 'experte') {
          this.modus = 'start';
          this.anwenden({});
          return;
        }
        this.zuSchritt(1, { fokus: true });
        publiziere('berater_cta', { berater: 'spiralen', ziel: 'begleiter' });
      }
      return;
    }
    if ((el = ziel.closest('[data-mv-spiralbegleiter-art]'))) {
      var radio = this.q('input[type="radio"][data-mv-berater-feld="art"][value="' + el.getAttribute('data-mv-spiralbegleiter-art') + '"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        ereignis(radio, 'change');
      } else if (radio && this.roh().bsp) {
        ereignis(radio, 'change');
      }
      this.zuSchritt(2, { fokus: true });
      return;
    }
    if (ziel.closest('[data-mv-spiralen-beispiel]')) {
      if (this.modus !== 'x10' && this.hatErgebnis()) this.zuSchritt(3, { fokus: true });
      return;
    }
    if (ziel.closest('[data-mv-spiralen-werk-planer], [data-mv-spiralen-baum-planer], [data-mv-spiralen-zum-planer]')) {
      if (this.altAktiv() === 'planen') this.experte({});
      return;
    }
    if ((el = ziel.closest('[data-mv-spiralbegleiter-gehe]'))) {
      if (!el.disabled) this.zuSchritt(Number(el.getAttribute('data-mv-spiralbegleiter-gehe')), { fokus: true });
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-aendern]')) {
      this.zuSchritt(1, { fokus: true });
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-zurueck]')) {
      if (this.schritt > 1) {
        this.zuSchritt(this.schritt - 1, { fokus: true });
      } else {
        this.altReiter('masse');
        this.modus = 'start';
        this.anwenden({});
        fokus(this.q('[data-mv-spiralbegleiter-frage]'));
      }
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-weiter]')) {
      var roh = this.roh();
      if (roh.bsp && this.hatErgebnis()) this.zuSchritt(3, { fokus: true });
      else if (roh.art) this.zuSchritt(2, { fokus: true });
      else {
        this.hinweis = true;
        this.anwenden({});
        var h = this.q('[data-mv-spiralbegleiter-hinweis]');
        this.statusZeigen(h ? h.textContent.replace(/\s+/g, ' ').trim() : '', true);
      }
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-weiteres]')) {
      this.weiteres();
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-experte]')) {
      this.experte({});
      publiziere('berater_cta', { berater: 'spiralen', ziel: 'experte' });
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-zurueck-begleiter]')) {
      this.altReiter('masse');
      this.zuSchritt(this.hatErgebnis() ? 3 : 1, { fokus: true });
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-menge], [data-mv-spiralbegleiter-entfernen]')) {
      this.merkAktion(ziel);
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-merk-leeren]')) {
      this.merk = [];
      this.speichern();
      this.merkZeigen();
      this.statusZeigen(TEXTE.geleert, false);
      fokus(this.q('[data-mv-spiralbegleiter-merk-schalter]'));
      return;
    }
    if ((el = ziel.closest('[data-mv-spiralbegleiter-merk-schalter]'))) {
      this.merkAufklappen(el.getAttribute('aria-expanded') !== 'true');
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-anfrage]')) {
      publiziere('berater_cta', { berater: 'spiralen', ziel: 'anfrage' });
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-angebot]')) {
      publiziere('berater_cta', { berater: 'spiralen', ziel: 'angebot' });
      return;
    }
    if (ziel.closest('[data-mv-spiralbegleiter-konfigurieren]')) {
      publiziere('berater_cta', { berater: 'spiralen', ziel: 'konfigurieren' });
    }
  };

  Begleiter.prototype.aenderung = function (el) {
    var name = el.getAttribute('data-mv-berater-feld');
    if (name === 'ebene' && el.checked) {
      if (el.value === 'x10' && this.modus !== 'x10') {
        this.vorX10 = { modus: this.modus, schritt: this.schritt };
        this.modus = 'x10';
      } else if (el.value !== 'x10' && this.modus === 'x10') {
        this.modus = this.vorX10.modus === 'x10' ? 'start' : this.vorX10.modus;
        this.schritt = this.vorX10.schritt;
        if (this.modus === 'begleiter' && this.schritt === 3 && !this.hatErgebnis()) this.schritt = this.roh().art ? 2 : 1;
      }
      this.anwenden({});
      return;
    }
    if (name === 'art' && el.checked) this.anwenden({});
  };

  Begleiter.prototype.eingabe = function () {
    this.fortschrittZeigen();
    this.buehneZeigen();
    this.ergebnisZusatz();
    this.merkZeigen();
  };

  Begleiter.prototype.absenden = function () {
    if (this.modus !== 'begleiter' || this.schritt !== 2) return;
    var erg = this.ergebnis();
    if (!anzahlFehler(erg) && !erg.x10 && this.hatErgebnis()) this.zuSchritt(3, { fokus: true });
    else this.anwenden({});
  };

  // ---- Delegation ------------------------------------------------------------------------------

  function wurzelVon(ziel) {
    return ziel && ziel.closest ? ziel.closest('[data-mv-spiralbegleiter]') : null;
  }

  function instanz(w) {
    if (!w || !MV.berater) return null;
    var inst = instanzen ? instanzen.get(w) : w.__mvSpiralbegleiter;
    if (inst) return inst;
    inst = new Begleiter(w);
    if (instanzen) instanzen.set(w, inst);
    else w.__mvSpiralbegleiter = inst;
    try {
      inst.start();
    } catch (e) {
      if (window.console && console.error) console.error('mv-spiralen: Start fehlgeschlagen', e);
    }
    return inst;
  }

  function alleStarten(bereich) {
    var liste = (bereich || document).querySelectorAll('[data-mv-spiralbegleiter]');
    for (var i = 0; i < liste.length; i++) instanz(liste[i]);
  }

  document.addEventListener('click', function (e) {
    var inst = instanz(wurzelVon(e.target));
    if (inst) inst.klick(e);
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('input[type="radio"][data-mv-berater-feld]')) return;
    var inst = instanz(wurzelVon(el));
    if (inst && !inst.intern) inst.aenderung(el);
  });

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('input[data-mv-berater-feld]:not([type="radio"])')) return;
    if (TEXTFELDER.indexOf(el.getAttribute('data-mv-berater-feld')) === -1) return;
    var inst = instanz(wurzelVon(el));
    if (inst) inst.eingabe();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-mv-berater-form]')) return;
    var inst = instanz(wurzelVon(form));
    if (inst) inst.absenden();
  });

  document.addEventListener('shopify:section:load', function (e) {
    alleStarten(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alleStarten(document); });
  } else {
    alleStarten(document);
  }
})();
